import HorizontalScroll from "@Components/HorizontalScroll";
import Image from "@Components/Image";
import styles from "./ScholarshipHowToApply.module.scss";
import { useResponsiveness } from "hooks/useResponsiveness";
import wrapperHOC from "@Utils/wrapperHOC";
import Subsection from "../Subsection";
import { SCHOLARSHIP_PAGE_STATIC_URL } from "constants/index";
import ScholarApplyIcon from "./icons/ScholarApply";
import ScholarAmazeIcon from "./icons/ScholarAmaze";
import ScholarReferIcon from "./icons/ScholarRefer";
import useTranslationHook from "hooks/useTranslationHook";

const StepCard = ({ stepNumber, icon, title, subTitle }: any) => (
  <>
    <div className={styles.stepCardOuter}>
      <div className={styles.stepCardInner}>
        <div className={styles.stepNumber}>{stepNumber}</div>
        {icon}
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.subTitle}>{subTitle}</div>
      </div>
    </div>
  </>
);

const ScholarshipHowToApply = () => {
  const { isAbove } = useResponsiveness();
  const isTabletOrDesktop = isAbove("md");
  const isXLScreen = isAbove("xl");
  const { t } = useTranslationHook();

  if (isTabletOrDesktop) {
    return (
      <div className={styles.subsectionContainer}>
        <div className={styles.header}>
          <h2 className={styles.titleDesktop}>{t("scholarship.howtoapply.title")}</h2>
          <h5 className={styles.subtitleDesktop}>{t("scholarship.howtoapply.subtitle")}</h5>
        </div>
        <div className={styles.content}>
          <HorizontalScroll
            className={`${styles.horizontalScroll} ${isXLScreen ? styles.noScroll : ""}`}
            showControls={isTabletOrDesktop && !isXLScreen}
          >
            <StepCard
              stepNumber={1}
              icon={<ScholarApplyIcon />}
              title={t("scholarship.howtoapply.step1.title")}
              subTitle={t("scholarship.howtoapply.step1.subtitle")}
            />
            <StepCard
              stepNumber={2}
              icon={<ScholarAmazeIcon />}
              title={t("scholarship.howtoapply.step2.title")}
              subTitle={t("scholarship.howtoapply.step2.subtitle")}
            />
            <StepCard
              stepNumber={3}
              icon={<ScholarReferIcon />}
              title={t("scholarship.howtoapply.step3.title")}
              subTitle={t("scholarship.howtoapply.step3.subtitle")}
            />
          </HorizontalScroll>
        </div>
      </div>
    );
  }

  return (
    <Subsection
      title={t("scholarship.howtoapply.title")}
      subtitle={t("scholarship.howtoapply.subtitle")}
      withSidePadding
      titleH2
    >
      <div className={styles.howToApplyVerticalContent}>
        <div className={styles.stepVerticalContainer}>
          <ScholarApplyIcon />
          <div className={styles.stepVerticalContent}>
            <div className={styles.stepVerticalHeader}>
              {t("scholarship.howtoapply.step1.title")}
            </div>
            <div className={styles.stepVerticalSubHeader}>
              {t("scholarship.howtoapply.step1.subtitle")}
            </div>
          </div>
          <Image
            src={`${SCHOLARSHIP_PAGE_STATIC_URL}/down_arrow.svg`}
            height={16}
            width={16}
            className={styles.downArrowIcon}
          />
        </div>

        <div className={styles.stepVerticalContainer}>
          <ScholarAmazeIcon />
          <div className={styles.stepVerticalContent}>
            <div className={styles.stepVerticalHeader}>
              {t("scholarship.howtoapply.step2.title")}
            </div>
            <div className={styles.stepVerticalSubHeader}>
              {t("scholarship.howtoapply.step2.subtitle")}
            </div>
          </div>
          <Image
            src={`${SCHOLARSHIP_PAGE_STATIC_URL}/down_arrow.svg`}
            height={16}
            width={16}
            className={styles.downArrowIcon}
          />
        </div>

        <div className={styles.stepVerticalContainer}>
          <ScholarReferIcon />
          <div className={styles.stepVerticalContent}>
            <div className={styles.stepVerticalHeader}>
              {t("scholarship.howtoapply.step3.title")}
            </div>
            <div className={styles.stepVerticalSubHeader}>
              {t("scholarship.howtoapply.step3.subtitle")}
            </div>
          </div>
        </div>
      </div>
    </Subsection>
  );
};

export default wrapperHOC(ScholarshipHowToApply, {
  componentName: "ScholarshipHowToApply-ScholarshipDesktop",
  showForChina: true,
});
